module.exports = __webpack_public_path__ + "img/bsc.45157357.svg";